import React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

const TicketColumnsSince = ({ row, name }) => {
  if (!row[name]) {
    return null;
  }

  return <div>{dayjs(row[name]).fromNow()}</div>;
};

export default TicketColumnsSince;
